/**
 * 福利系统
 *
 * appid: 13024
 *
 */
import http from '@utils/http';
import config from '@config';

// 通过工号查询过生日信息
export function queryOrderDetailsInfos(data) {
  return http.post(`${config.welfareHost}/api/welfare/cake/queryOrderDetailsInfos`, data);
}

// 查询蛋糕信息
export function queryCakeInfos(data) {
  return http.post(`${config.welfareHost}/api/welfare/cake/queryCakeInfos`, data);
}

// 查询配送地址
export function queryContactsAddress(data) {
  return http.post(`${config.welfareHost}/api/welfare/cake/queryContactsAddress`, data);
}

// 创建蛋糕订单
export function createCakeOrder(data) {
  return http.post(`${config.welfareHost}/api/welfare/cake/createCakeOrder`, data);
}

// 取消蛋糕订单
export function cancelCakeOrder(data) {
  return http.post(`${config.welfareHost}/api/welfare/cake/cancelCakeOrder`, data);
}


// 【列表】查询当前用户所属过期人员名单
export function queryCurrentUserExpireList(data) {
  return http.post(`${config.welfareHost}/api/welfare/cake/queryCurrentUserExpireList`, data);
}

// 【列表】查询当前用户所建订单
export function queryCurrentUserOrders(data) {
  return http.post(`${config.welfareHost}/api/welfare/cake/queryCurrentUserOrders`, data);
}

// 【列表】查询当前用户取消订单
export function queryCancelCurrentUserOrders(data) {
  return http.post(`${config.welfareHost}/api/welfare/cake/queryCancelCurrentUserOrders`, data);
}